import type { IGroup } from '~/types/group'

import config from '~/config'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'
import { request } from '~/utils/request'

export const getGroups = (): Promise<IPaginatedResponse<IGroup>> => {
  return request({
    params: {
      size: DEFAULT_ITEMS_PER_PAGE_VALUE,
    },
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/search`,
  })
}

export const getGroup = (id: string): Promise<IGroup> => {
  return request({
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${id}`,
  })
}

export const updateGroupGeneralInformation = ({
  description,
  groupId,
  groupName: group_name,
}: {
  description: string
  groupId: string
  groupName: string
}): Promise<IGroup> => {
  return request({
    data: {
      description,
      group_name,
    },
    method: 'PUT',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${groupId}`,
  })
}

export const createGroup = ({
  description,
  groupName: group_name,
}: {
  description: string
  groupName: string
}): Promise<IGroup> => {
  return request({
    data: [
      {
        description,
        group_name,
      },
    ],
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group`,
  })
}

export const addRolesToGroup = ({ groupId, roleIds }: { groupId: string; roleIds: string[] }): Promise<IGroup> => {
  return request({
    data: roleIds,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${groupId}/role`,
  })
}

export const addUsersToGroup = ({ groupId, userIds }: { groupId: string; userIds: string[] }): Promise<IGroup> => {
  return request({
    data: userIds,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${groupId}/user`,
  })
}

export const deleteRolesFromGroup = ({ groupId, roleIds }: { groupId: string; roleIds: string[] }): Promise<IGroup> => {
  return request({
    data: roleIds,
    method: 'DELETE',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${groupId}/role`,
  })
}
export const deleteUsersFromGroup = ({ groupId, userId }: { groupId: string; userId: string }): Promise<IGroup> => {
  return request({
    data: [userId],
    method: 'DELETE',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/group/${groupId}/user`,
  })
}
